import { render, staticRenderFns } from "./video-media-wrap.vue?vue&type=template&id=644fd6e0&scoped=true&"
import script from "./video-media-wrap.vue?vue&type=script&lang=ts&"
export * from "./video-media-wrap.vue?vue&type=script&lang=ts&"
import style0 from "./video-media-wrap.vue?vue&type=style&index=0&id=644fd6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644fd6e0",
  null
  
)

export default component.exports